import React from "react"
import { Link as MuiLink } from "@material-ui/core"
import { Link as GatsbyLink, GatsbyLinkProps } from "gatsby"

const Link: React.FC<GatsbyLinkProps<{}>> = React.forwardRef(function Link(
  props,
  ref
) {
  // @ts-ignore
  return <MuiLink component={GatsbyLink} ref={ref} {...props} />
})

export default Link
